var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightfulAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3782 3.88287L6.95176 5.47568C7.58888 7.24348 8.98098 8.63559 10.7488 9.27271L12.3416 9.84626C12.4852 9.89841 12.4852 10.102 12.3416 10.1534L10.7488 10.727C8.98098 11.3641 7.58888 12.7562 6.95176 14.524L6.3782 16.1168C6.32606 16.2604 6.1225 16.2604 6.07107 16.1168L5.49752 14.524C4.86039 12.7562 3.46829 11.3641 1.70049 10.727L0.107675 10.1534C-0.0358918 10.1013 -0.0358918 9.89769 0.107675 9.84626L1.70049 9.27271C3.46829 8.63559 4.86039 7.24348 5.49752 5.47568L6.07107 3.88287C6.1225 3.73859 6.32606 3.73859 6.3782 3.88287Z",
    fill: "url(#paint0_linear_177_717)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5462 0.0551769L13.8369 0.861582C14.1597 1.75656 14.8647 2.46153 15.7597 2.78438L16.5661 3.07509C16.6389 3.10151 16.6389 3.20437 16.5661 3.2308L15.7597 3.5215C14.8647 3.84435 14.1597 4.54933 13.8369 5.4443L13.5462 6.25071C13.5198 6.32356 13.4169 6.32356 13.3905 6.25071L13.0998 5.4443C12.7769 4.54933 12.0719 3.84435 11.177 3.5215L10.3706 3.2308C10.2977 3.20437 10.2977 3.10151 10.3706 3.07509L11.177 2.78438C12.0719 2.46153 12.7769 1.75656 13.0998 0.861582L13.3905 0.0551769C13.4169 -0.0183923 13.5205 -0.0183923 13.5462 0.0551769Z",
    fill: "url(#paint1_linear_177_717)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5462 13.7497L13.8369 14.5561C14.1597 15.4511 14.8647 16.1561 15.7597 16.4789L16.5661 16.7696C16.6389 16.796 16.6389 16.8989 16.5661 16.9253L15.7597 17.216C14.8647 17.5389 14.1597 18.2439 13.8369 19.1388L13.5462 19.9452C13.5198 20.0181 13.4169 20.0181 13.3905 19.9452L13.0998 19.1388C12.7769 18.2439 12.0719 17.5389 11.177 17.216L10.3706 16.9253C10.2977 16.8989 10.2977 16.796 10.3706 16.7696L11.177 16.4789C12.0719 16.1561 12.7769 15.4511 13.0998 14.5561L13.3905 13.7497C13.4169 13.6769 13.5205 13.6769 13.5462 13.7497Z",
    fill: "url(#paint2_linear_177_717)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_177_717",
    x1: 15.9027,
    y1: 18.74,
    x2: 4.85986,
    y2: 5.82167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00265844,
    stopColor: "#FF37DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_177_717",
    x1: 18.3697,
    y1: 7.57934,
    x2: 12.7769,
    y2: 1.03696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00265844,
    stopColor: "#FF37DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_177_717",
    x1: 18.3697,
    y1: 21.2738,
    x2: 12.7774,
    y2: 14.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00265844,
    stopColor: "#FF37DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightfulAi);
export default __webpack_public_path__ + "static/media/InsightfulAi.a15d9b44ef2ba198fdae082c8e259ae8.svg";
export { ForwardRef as ReactComponent };